import { useState, useRef, useContext } from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Box,
  Typography,
} from '@mui/material';

import { DataLoading, Button as CustomButton } from '../common';
import colors from '../../assets/colors';
import { directPayment } from '../../utils/api';
import FarmContext from '../../store/farm-context';

const NewDirectPaymentDialog = ({ open, handleAction }) => {
  const hiddenFileInput = useRef(null);
  const [isUploading, setIsUploading] = useState(false);
  const [successful, setSuccessful] = useState(true);
  const farmCTX = useContext(FarmContext);

  const handleClose = () => {
    handleAction(false);
  };
  const handleInputClick = (event) => {
    hiddenFileInput.current.click();
  };

  const onChangeHandler = async (event) => {
    await uploadFile(event.target.files[0]);
  };

  const uploadFile = (fileup) => {
    setIsUploading(true);
    const data = new FormData();
    data.append('file', fileup);
    directPayment
      .add(farmCTX.farmID, data)
      .then((result) => {
        if (result.status === 200) {
          setIsUploading(false);
          handleClose();
        }
      })
      .catch(() => {
        setIsUploading(false);
        setSuccessful(false);
      });
  };

  return (
    <Dialog
      PaperProps={{
        style: {
          backgroundColor: colors.white,
          color: colors.oldAgroweGreen,
          width: '65%',
        },
      }}
      open={open}
    >
      <DialogTitle align="center" sx={{ p: 2, mt: 1 }}>
        Umieść nowy wniosek o dopłaty bezpośrednie
      </DialogTitle>
      <DialogContent>
        {isUploading ? (
          <DataLoading />
        ) : successful ? (
          <Box component="div" sx={{ marginTop: 1 }}>
            <CustomButton
              type="submit"
              variant="contained"
              fullWidth
              onClick={handleInputClick}
            >
              Umieść wniosek o dopłaty bezpośrednie
            </CustomButton>
            <input
              ref={hiddenFileInput}
              style={{ display: 'none' }}
              id="file"
              type="file"
              name="file"
              onChange={onChangeHandler}
              aria-label="fileInput"
            />
          </Box>
        ) : (
          <Grid
            container
            item
            xs={12}
            justifyContent="center"
            alignItems="center"
            sx={{ textAlign: 'center', marginBottom: '8%' }}
          >
            <Typography variant={'h5'} sx={{ color: colors.redError }}>
              Podczas analizy pliku wystąpił błąd, spróbuj ponownie.
            </Typography>
          </Grid>
        )}
        <CustomButton variant="contained" fullWidth onClick={handleClose}>
          Zamknij okno
        </CustomButton>
      </DialogContent>
    </Dialog>
  );
};

export default NewDirectPaymentDialog;
